<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="marks"
    :items-per-page="10"
    :mobile-breakpoint="900"
    :footer-props="{ 'items-per-page-text': 'Số kỳ kiểm tra mỗi trang' }"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Kỳ kiểm tra thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} kỳ kiểm tra
    </template>
    <template v-slot:[`item.mark`]="{ item }">
      <div style="height: 100%; ">
        <StudentMarkCard :item="item" />
      </div>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.name }}
      </div>
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.student.dob | getDate }}
      </div>
    </template>
    <template v-slot:[`item.student`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        <StudentExamCard :student="item.student" />
      </div>
    </template>
    <template v-slot:[`item.examCode`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.examCode }}
      </div>
    </template>
    <template v-slot:[`item.reviewDate`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.reviewDate | getDate }}
      </div>
    </template>
    <template v-slot:[`item.action`]="{}">
      <div style="height: 100%; padding-top: 8px" class="d-flex justify-center">
        <StudentMarkActions></StudentMarkActions>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import StudentMarkCard from './StudentMarkCard.vue'
import StudentMarkActions from './StudentMarkActions.vue'
import StudentExamCard from '../../../components/basic/card/StudentExamCard.vue'
const originHeaders = [
  {
    text: 'Kỳ kiểm tra',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Môn - Kết quả',
    value: 'mark',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Hạn phúc khảo',
    value: 'reviewDate',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true,
    width: '100'
  }
]

export default {
  props: {
    exams: Array,
    marks: Array
  },
  components: {
    StudentMarkCard,
    StudentMarkActions,
    StudentExamCard
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {},
  watch: {},
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    },
    getDate: item => {
      if (item) {
        return moment(item)
          .utcOffset(0)
          .format('DD/MM/YYYY')
      }
      return 'Chưa có thông tin'
    }
  }
}
</script>
